import CountryAssetsModel from "../../../Global/Models/Assets/CountryAssetsModel";

export default class ProfileCountryModel {
  public id: string = null;
  public name: string = null;
  public assets: CountryAssetsModel = null;
}
